var Pixel = Pixel || {};

Pixel.Marin = (function (PixelBase) {
	var Marin = PixelBase.extend({
		landingPageView: function () {
			this._push(['trackPage']);
		},

		registrationSuccess: function () {
			this._pushTrans({
				convType: 'signup'
			});
		},

		purchaseSuccess: function (opts) {
			opts = opts || {};
			this._pushTrans({
				convType: 'sales',
				orderId: opts.orderNo,
				price: opts.totalValue
			});
		},

		_pushTrans: function (opts) {
			this._addMarinScript();
			this._api.push(['addTrans', { items: [opts] }]);
			this._api.push(['processOrders']);
		},

		_push: function (obj) {
			this._addMarinScript();
			this._api.push(obj);
		},

		_addMarinScript: function () {
			var _id = 'marin-pixel-script';

			var _element = document.getElementById(_id);
			_element && _element.parentNode.removeChild(_element);

			window._mTrack = [];

			var _this = this;
			(function () {
				var mClientId = _this._id;
				var mProto = ('https:' == document.location.protocol ? 'https://' : 'http://');
				var mHost = 'tracker.marinsm.com';
				var mt = document.createElement('script');
				mt.id = _id;
				mt.type = 'text/javascript';
				mt.async = true;
				mt.src = mProto + mHost + '/tracker/async/' + mClientId + '.js';
				var fscr = document.getElementsByTagName('script')[0]; fscr.parentNode.insertBefore(mt, fscr);
			})();

			this._api = window._mTrack;
		}
	});

	return Marin;
})(Pixel.PixelBase);

!function (Pixel, GlobalSettings) {
	if (!GlobalSettings.MAE) {
		return;
	}

	new Pixel.Marin({
		id: GlobalSettings.MAI
	});
}(Pixel, GlobalSettings);
